
/* eslint-disable */
import BASE from '../../../../../vue.config.js'
import listado from '../../../../assets/js/ScriptListadoGeneral.js';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";

const $ = require('jquery')
window.$ = $

export default {
  data: () => ({
    languages: lang,
    fechaInicio: '',
    grupos: [],
    pagina: 'grupos',
    estatus: 1,
    del: false,
    edit: false,
    paymentCalendar: false,
    showDetail: false,
    estatusRegistro: '',
    idGrupo: '',
    editGrupoName: '',
    editGrupoCupo: '',
    isErrorCupo: false,
    currentGroupInscritos: 0,
    permisoGuardar: 0,
    permisoEditar: 0,
    permisoActivaInactivar: false,
    permisoEliminar: 0,
    permisoConsultar: false,
    activePrompt: false,
    periodoDuracion: '',
    idPeriodo: 0,
    periodo: 0,
    fechaInicial: '',
    fechaFinal: '',
    listaPeriodos: [],
    disabledCalPagos: true,
    action: '',
    urlZoom: '',
    urlValidacionZoom: '',
    validador: true,
    activeUpload: false,
    filesData: [],
    arrFilesUpload: [],
    baseImg: '',
    nombreGrupo: '',
    mostarBotonGuardar: 0,
    periodos: [
      {
        periodo: 1,
        descripcionPeriodo: 'Mensual'
      }
    ],
  }),
  methods: {
    getListaGrupos(status) {
      this.grupos = [];
      var tipo = 1; // listado general de grupos (administarativos)
      fetch(`${this.$BASE.baseUrl}api/ListadoGrupos/${status}/${tipo}`, {
        method: 'GET',
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos',
          'paginaOrigen': 'listadoGrupos'
        }
      })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
          if (rs.status == 200) {
            rs.result.grupos.forEach((itemP, indexP) => {
              itemP.colorStatus = itemP.estatusGrupo == 'True' ? 'success' : 'warning';
              this.grupos.push(itemP);
            });
            rs.result.permisos.forEach((item, indx) => {
              if (item.id == 1) { this.permisoGuardar = 1; }
              if (item.id == 2) { this.permisoEditar = true; }
              if (item.id == 3) { this.permisoActivaInactivar = true; }
              if (item.id == 4) { this.permisoEliminar = 1; }
              if (item.id == 6) { this.permisoConsultar = true; }
            });
          }
        });
    },
    comboEstatus() {
      this.estatusRegistro = [
        { text: 'Activo', value: 1, isSelected: false },
        { text: 'Inactivo', value: 0, isSelected: false },
        { text: 'Todos', value: 2, isSelected: false }
      ]
    },
    cambiarStatus(id) {
      listado.methods.CambiarStatus(id, this.pagina);
    },
    EliminarRegistro() {
      listado.methods.EliminarRegistro(this.idGrupo, this.pagina);
      this.del = false;
    },
    exportarExcel(id) {
      fetch(`${this.$BASE.baseUrl}api/reporteEvaluacionesPorGrupo/${id}/0`, {
        method: 'GET',
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos',
          'Accept': 'application/vnd.ms-excel',
        },
        responseType: 'blob'
      })
        .catch(error => console.log('error:', error))
        .then(response => response.blob())
        .then(blob => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "evaluaciones.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },

    ObtenerReporteAsitencia(id) {
      fetch(`${this.$BASE.baseUrl}api/reporteAsistenciasPorGrupo/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos',
          'Accept': 'application/vnd.ms-excel',
        },
        responseType: 'blob'
      })
        .catch(error => console.log('error:', error))
        .then(response => response.blob())
        .then(blob => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = "asistencias.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },

    comboPeriodoDuracion() {
      this.periodoDuracion = [
        { text: '1 año', value: 1, isSelected: false },
        { text: '1 año y medio', value: 2, isSelected: false },
        { text: '2 años', value: 3, isSelected: false },
        { text: '3 años', value: 4, isSelected: false },
        { text: '4 años', value: 5, isSelected: false }
      ]
    },

    GuardarUrlZoom() {
      this.ValidarValores();
      if (this.validador) {
        let objeto = {
          'idGrupo': this.idGrupo,
          'urlZoom': this.urlZoom
        }
        fetch(`${this.$BASE.baseUrl}api/EditarUrlZoom`, {
          method: 'POST',
          headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina': 'grupos',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objeto),
        })
          .then(rs => rs.json())
          .catch(error => console.log('error:', error))
          .then(rs => {
            this.MostrarMensaje(rs.status);
          })
      } else {
        this.activePrompt = true;
      }
    },
    ObtenerUrlZoom() {

      fetch(`${this.$BASE.baseUrl}api/ObtenerUrlZoom/${this.idGrupo}`, {
        method: 'GET',
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos'
        }
      })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
          if (rs.status == 200) {
            this.urlZoom = rs.result;
          }
        });
    },
    ValidarValores() {
      if (this.urlZoom == '') { this.validador = false; this.urlValidacionZoom = 'El campo URL es obligatorio.' }
    },
    checkErrorCupo() {
      let isNum = true;
      let arrayGroupCupo = _.split(this.editGrupoCupo, '');
      arrayGroupCupo.forEach(element => {
        if (isNaN(parseInt(element))) { isNum = false }
      });
      if (!isNum) { this.editGrupoCupo = '' }
      if (this.editGrupoCupo > 3) { this.editGrupoCupo = this.editGrupoCupo.slice(0, 3) }
      if (this.editGrupoCupo < this.currentGroupInscritos) {
        this.isErrorCupo = true;
      } else {
        this.isErrorCupo = false;
      }
    },
    editGroup() {
      let grupoEditObj = {
        idGrupo: this.idGrupo,
        nombreGrupo: this.editGrupoName,
        cupo: this.editGrupoCupo
      };
      fetch(`${this.$BASE.baseUrl}api/EditarGrupo`, {
        method: 'POST',
        body: JSON.stringify(grupoEditObj),
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos',
          'Content-Type': 'application/json'
        }
      })
        .then(rs => rs.json())
        .catch(error => {
          console.log('error: ', error)
          this.edit = false;
        })
        .then(rs => {
          if (rs.status == 200) {
            this.showNotify(rs.status, null, 'Se editó el grupo satisfactoriamente.');
          } else if (rs.status == 428) {
            this.showNotify(rs.status, null, 'No se pudo realizar la acción, favor de revisar el cupo del grupo.');
          } else {
            this.showNotify(rs.status);
          }
          this.consultar();
          this.edit = false;
        });
    },
    showEditPopup(group) {
      this.idGrupo = group.idGrupo;
      this.editGrupoName = group.clave;
      this.editGrupoCupo = group.cupo;
      this.currentGroupInscritos = group.inscritos;
      this.isErrorCupo = false;
      this.edit = true;
    },
    consultar() {
      this.grupos = [];
      this.getListaGrupos(this.estatus);
    },
    navigateToConsultarGrupo(routeObj) {
      if (routeObj.params.level < routeObj.params.grupoSeleccionado.nivelActual) {
        // Se asigna horarioGrupo = 1 porque vamos a entrar a un nivel anterior
        // esto signigica que el nivel anterior sí tiene un horario asignado
        routeObj.params.grupoSeleccionado.horarioGrupo = 1;
        routeObj.params.grupoSeleccionado.nivelAnterior = true;
      } else {
        routeObj.params.grupoSeleccionado.nivelAnterior = false;
      }
      this.$router.push(routeObj);
    },

    async createCalendarioPagos() {

      const startDate = moment(this.fechaInicial).format('YYYY-MM-DD');
      const endDate = moment(this.fechaFinal).format('YYYY-MM-DD');

      const data = {
        fechaInicial: parseInt(startDate.split('-').join('')),
        fechaFinal: parseInt(endDate.split('-').join('')),
        periodo: 1,
        pagoInscripcion: 0,
        idGrupo: this.idGrupo,
        accionRealizada: 1
      };

      if (this.fechaInicial != '' && this.fechaFinal != '') {

        fetch(`${this.$BASE.baseUrl}api/calendarioPagos`, {
          method: 'POST',
          headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina': 'grupos',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        })
          .then(rs => rs.json())
          .catch(error => console.log('error:', error))
          .then(rs => {
            this.listaPeriodos = rs.result.listaCalendarioPagos.listaPeriodos;
            this.mostarBotonGuardar = 1;
            document.getElementsByTagName("body")[0].style = 'overflow: hidden;';
          })
      }
    },

    async saveCalendarioPagos() {
      const startDate = moment(this.fechaInicial).format('YYYY-MM-DD');
      const endDate = moment(this.fechaFinal).format('YYYY-MM-DD');

      const data = {
        fechaInicial: parseInt(startDate.split('-').join('')),
        fechaFinal: parseInt(endDate.split('-').join('')),
        periodo: 1,
        pagoInscripcion: 0,
        idGrupo: this.idGrupo,
        accionRealizada: 2
      };

      if (this.fechaInicial != '' && this.fechaFinal != '') {

        fetch(`${this.$BASE.baseUrl}api/calendarioPagos`, {
          method: 'POST',
          headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina': 'grupos',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        })
          .then(rs => rs.json())
          .catch(error => console.log('error:', error))
          .then(rs => {

            this.$vs.notify({ color: 'success', title: 'Exitoso', text: 'El calendario de pagos se ha guardado correctamente.' });
            this.paymentCalendar = false;
            this.listaPeriodos = [];
            this.mostarBotonGuardar = 0;
            this.fechaInicial = "";
            this.fechaFinal = "";
            this.periodo = 0;
            this.idGrupo = '';
          })
      }else{


      }
    },

    async obtenerCalendarioPagos() {

      this.listaPeriodos = [];
      this.mostarBotonGuardar = 0;
      this.fechaInicial = "";
      this.fechaFinal = "";
      this.periodo = 0;
    

      fetch(`${BASE.baseUrl}api/consultarCalendarioPagos/${this.idGrupo}`, {
        method: 'GET',
        headers: {
          'Authorization': sessionStorage.getItem('token'),
          'pagina': 'grupos',
        }
      })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
          if (rs.status == 200) {

            this.listaPeriodos = rs.result.listaPeriodos;
            this.mostarBotonGuardar = 1;

            const startDate = moment(rs.result.fechaInicial).format('YYYY/MM//DD');
            const endDate = moment(rs.result.fechaFinal).format('YYYY-MM-DD');

            this.fechaInicial = startDate;
            this.fechaFinal = endDate;
            this.periodo = rs.result.periodo;

            document.getElementsByTagName("body")[0].style = 'overflow: hidden;';
          }
        });
    },

    OcultarBoton() {
      this.mostarBotonGuardar = 0;
    },

    MostrarMensaje(idResupesta) {

      switch (idResupesta) {
        case 200:
          this.$vs.notify({ color: 'success', title: 'Exitoso', text: 'El registro se ha guardado correctamente.' })
          this.activePrompt = false;
          break;
        case 500:
          this.$vs.notify({ color: 'danger', title: 'Error', text: 'Ha ocurrido un error. Favor de ponerse en contacto con el administrador.' })
          break;
        default:
          this.$vs.notify({ color: 'warning', title: 'Alerta', text: 'Favor de ponerse en contacto con el administrador.' })
          break;
      }
    },
    onChange(e) {
      this.filesData = e.target.files;
    },

    cancelUpload() {
      this.filesData = [];
    },

    handleUpload() {
      if (this.filesData.length > 0) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", sessionStorage.getItem('token'));
        myHeaders.append("pagina", "grupos");

        const formdata = new FormData();
        formdata.append("objeto", JSON.stringify({ idGrupo: this.idGrupo }));

        for (const file of this.filesData) {
          formdata.append('archivos', file);
        }

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${this.$BASE.baseUrl}api/AgregarDocumentos`, requestOptions)
          .then(response => response.text())
          .then(result =>
            this.MostrarMensaje(JSON.parse(result).status),
            this.filesData = [],
          )
          .catch(error => {
            console.log(error);
            this.MostrarMensaje(error);
          });
      } else {
        this.activeUpload = true;
        this.showNotify(428, null, 'Debes seleccionar por lo menos un documento.');
      }
    },
    async getFileUpload() {

      this.baseImg = BASE.baseUrl;
      const rs = await fetch(`${this.$BASE.baseUrl}api/ListaDocumentos/${this.idGrupo}`, {
        method: 'GET',
        headers: { Authorization: sessionStorage.getItem('token') }
      });
      const { status, result } = await rs.json();

      if (status === 200) {
        this.arrFilesUpload = result;
      }
    },
    async handleDeleteFile(idDocumento) {
      // this.del = true;
      const rs = await fetch(`${this.$BASE.baseUrl}api/EliminarDocumentos/${idDocumento}`, {
        method: 'POST',
        headers: { Authorization: sessionStorage.getItem('token') }
      });
      const { status } = await rs.json();
      if (status === 200) {
        this.showNotify(200, null, 'El documento se eliminó satisfactoriamente.');
        this.getFileUpload();
      }
    }
  },
  components: {
    Datepicker
  },
  mounted() {
    this.getListaGrupos(1);
    this.comboEstatus();
    this.comboPeriodoDuracion();
  },

  updated() {
    if (this.urlZoom != '') { this.urlValidacionZoom = ''; this.validador = true; }
  },

  watch: {
    paymentCalendar: (val) => {
      if (!val) {
        document.getElementsByTagName("body")[0].style = 'overflow: inherit;';
      }
    },
  }
}
